
/* eslint-disable @typescript-eslint/no-explicit-any */

import { defineComponent, nextTick } from 'vue';
import PanelHeader from '@/components/panel-header.vue';
import focus from '@/libs/focus';
import isEmail from 'validator/lib/isEmail';
import {
  LABEL_CONTINUE,
  LABEL_INVALID_EMAIL,
  LABEL_PASSWORD_RESET,
  LABEL_PASSWORD_RESET_HELP,
  LABEL_PASSWORD_RESET_RECOVERY_EMAIL_HELP,
  LABEL_USERNAME_OR_PRIMARY_EMAIL,
  LABEL_RECOVERY_EMAIL,
} from '@/libs/i18nLabels';
import passwordState from './passwordState';

export default defineComponent({
  components: {
    PanelHeader,
  },

  props: {
    serviceName: String,
    displayBack: Boolean,
  },

  emits: ['back'],
  setup() {
    return {
      LABEL_CONTINUE,
      LABEL_INVALID_EMAIL,
      LABEL_PASSWORD_RESET,
      LABEL_PASSWORD_RESET_HELP,
      LABEL_PASSWORD_RESET_RECOVERY_EMAIL_HELP,
      LABEL_RECOVERY_EMAIL,
      LABEL_USERNAME_OR_PRIMARY_EMAIL,
    };
  },
  data() {
    return {
      email: '',
      processing: false,
      isEmailInvalid: false,
      emailLabel: '',

      recoveryEmail: '',
      displayRecoveryEmail: false,
      isRecoveryEmailInvalid: false,
      recoveryLabel: '',

      emailSend: '',
    };
  },

  methods: {
    onEmailKeyUp() {
      if (!this.isEmailInvalid) {
        return;
      }
      this.isEmailInvalid = false;
      this.emailLabel = '';
    },

    onRecoveryKeyUp() {
      if (!this.isRecoveryEmailInvalid) {
        return;
      }
      this.isRecoveryEmailInvalid = false;
      this.recoveryLabel = '';
    },

    focusEmailField() {
      focus(this.$refs.emailField);
    },

    focusRecoveryField() {
      focus(this.$refs.recoveryField);
    },

    onBack() {
      // cleanup
      this.isRecoveryEmailInvalid = false;
      this.recoveryLabel = '';
      this.recoveryEmail = '';
      this.displayRecoveryEmail = false;
    },

    async sendCode() {
      if (this.email.length < 2) {
        this.focusEmailField();
        return;
      }

      if (this.email.indexOf('@') >= 0 && !isEmail(this.email)) {
        this.isEmailInvalid = true;
        this.emailLabel = this.$t(LABEL_INVALID_EMAIL);
        this.focusEmailField();
        return;
      }

      if (this.displayRecoveryEmail) {
        // recovery email validation
        if (this.recoveryEmail.trim().length < 2) {
          this.focusRecoveryField();
          return;
        }

        if (!isEmail(this.recoveryEmail)) {
          this.isRecoveryEmailInvalid = true;
          this.recoveryLabel = this.$t(LABEL_INVALID_EMAIL);
          this.focusRecoveryField();
          return;
        }
      }

      this.processing = true;

      this.isEmailInvalid = false;
      this.emailLabel = '';
      const res = await passwordState.sendResetLink(
        { username: this.email, email: this.displayRecoveryEmail ? this.recoveryEmail : undefined },
        this.$i18n,
      );

      const hasError = !res || res.errorCode;
      const errorMessage = res && res.errorMessage;

      if (!this.displayRecoveryEmail) {
        // firstpanel
        if (hasError) {
          if (errorMessage) {
            this.isEmailInvalid = true;
            this.emailLabel = errorMessage || '';
          }

          this.focusEmailField();
        } else {
          // display recovery panel
          this.displayRecoveryEmail = true;

          nextTick(() => {
            this.focusRecoveryField();
          });
        }
      } else if (this.displayRecoveryEmail) {
        // second panel
        if (hasError) {
          if (errorMessage) {
            this.isRecoveryEmailInvalid = true;
            this.recoveryLabel = errorMessage || '';
          }
          this.focusRecoveryField();
        } else {
          // success
          this.emailSend = res?.successMessage || '?';
        }
      }

      this.processing = false;
    },
  },

  mounted() {
    focus(this.$refs.emailField);
  },
});
